<template>
  <div class="sub-section">
    <b-field
      class="input-field"
      label="Pivot measure columns by:">
      <CompanyDimensionRefSelect v-model="inputs.dimension" />
    </b-field>
  </div>
</template>

<script>

  import CompanyDimensionRefSelect from '@/components/reports/config/dimensions/CompanyDimensionRefSelect'

  export default {
    name: 'PivotEditorDimensionTab',
    components: {
      CompanyDimensionRefSelect,
    },
    props: {
      value: {
        type: Object,
        default: () => {},
      },
      errors: {
        type: Array,
        default: () => [],
      },
    },
    computed: {

      inputs: {
        get () {
          return this.value || {}
        },
        set (value) {
          this.$emit('input', value ? value : null)
        },
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>
